import PropTypes from 'prop-types';

import LegendItem from 'client/pages/MapPage/components/Legend/LegendItem/LegendItem';

import styles from './LegendCategory.module.scss';

const LegendCategory = ({
    categoryNode,
    isLast,
    currentLocale,
    legendItems
}) => {
    if (!categoryNode || legendItems.length === 0) {
        return null;
    }

    const categoryName = categoryNode.data.name[currentLocale];

    return (
        <div className={styles.category} data-testid="mapPage.menu.legendCategory">
            <h3 className="govuk-heading-s">{categoryName}</h3>
            {legendItems.map(({ id, icon, label }) => (
                <LegendItem key={id} prefix={icon}>
                    {label}
                </LegendItem>
            ))}
            {!isLast && <hr className="govuk-section-break govuk-section-break--m govuk-section-break--visible"/>}
        </div>
    );
};

LegendCategory.propTypes = {
    categoryNode: PropTypes.object,
    isLast: PropTypes.bool,
    currentLocale: PropTypes.string,
    legendItems: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        icon: PropTypes.node,
        label: PropTypes.string
    }))
};

LegendCategory.defaultProps = {
    categoryNode: null,
    isLast: false,
    currentLocale: 'en',
    legendItems: []
};

export default LegendCategory;
